import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { Role } from '../../enums';

export interface IUserData {
    readonly userId: string,
    readonly nickname?: string,
    readonly picture?: string,
    readonly name?: string,
    readonly role: Role
}

export class UserDataClient {

    private readonly resourceHostId: string;

    constructor(private readonly authService: IAuthServiceV2, readonly stage: string, private readonly useNewUserDataService = false) {
        this.resourceHostId = useNewUserDataService ? `myvw-user-data-service-${stage}` : `myvw-idk-token-exchanger-${stage}`;
    }

    public async getUserData(vin: string, isWcar: boolean, pictures?: boolean, roles?: Role[]): Promise<IUserData[]> {
        let response;

        if (this.useNewUserDataService) {
            if (roles) {
                response = await this.authService.get(this.resourceHostId,
                    `vehicles/${vin}/users?isWcar=${isWcar}&pictures=${pictures ?? false}&roles=${roles}`);
            } else {
                response = await this.authService.get(this.resourceHostId,
                    `vehicles/${vin}/users?isWcar=${isWcar}&pictures=${pictures ?? false}`);
            }
        } else {
            response = await this.authService.get(this.resourceHostId, `user-data/${vin}?isWcar=${isWcar}`);
        }

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as IUserData[];

    }
}